export default "__VITE_ASSET__03f15c51__"